import { object, number } from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const validationSchema = object().shape({
  programId: number().nullable().required('Field is required'),
});

export default yupResolver(validationSchema);
